/* eslint-disable import/no-default-export */
import { ExperimentDetails } from 'app/gamma/src/components/popovers/experiment-details/experiment-details';
import Cookies from 'js-cookie';
import { State } from 'app/gamma/src/modules/types';
import React from 'react';
import { connect } from 'react-redux';
import { getExperimentDetails } from 'app/gamma/src/selectors/channels';
import { ExperimentDetailsObject } from 'app/gamma/src/types/experiment';

interface ExperimentDetailsProps {
  experimentDetails: ExperimentDetailsObject;
  experimentName: string;
}

class ExperimentDetailsContainer extends React.Component<
  ExperimentDetailsProps
> {
  cookieName = () => `force_${this.props.experimentName}`;

  onVariationOverride = (variationName: string) => {
    Cookies.set(this.cookieName(), variationName, { path: '/', expires: 30 });
    document.location.reload();
  };

  onVariationRemove = () => {
    Cookies.set(this.cookieName(), '', { path: '/', expires: -1 });
    document.location.reload();
  };

  render() {
    const { experimentDetails, experimentName } = this.props;

    return (
      <ExperimentDetails
        experimentName={experimentName}
        onVariationOverride={this.onVariationOverride}
        onVariationRemove={this.onVariationRemove}
        {...experimentDetails}
      />
    );
  }
}

const mapStateToProps = (
  state: State,
  ownProps: {
    experimentName: string;
  },
) => {
  return {
    experimentDetails: getExperimentDetails(ownProps.experimentName),
  };
};

export default connect(mapStateToProps)(ExperimentDetailsContainer);
